import { render, staticRenderFns } from "./ResourceLanguageDropdown.vue?vue&type=template&id=363b33f7&scoped=true"
import script from "./ResourceLanguageDropdown.vue?vue&type=script&lang=js"
export * from "./ResourceLanguageDropdown.vue?vue&type=script&lang=js"
import style0 from "./ResourceLanguageDropdown.vue?vue&type=style&index=0&id=363b33f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b33f7",
  null
  
)

export default component.exports